<template>
  <v-list-item
    dense
  >
    <v-list-item-content>
      <v-list-item-title>
        {{ product.label }}
        <product-template-chip
          class="ml-3"
          :template-id="product.template"
        />
      </v-list-item-title>
      <v-list-item-subtitle>{{ product.description }}</v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action v-if="product.isArchived">
      <v-chip
        small
        outlined
      >
        <v-icon
          small
          left
        >
          archive
        </v-icon>Archived
      </v-chip>
    </v-list-item-action>
    <v-list-item-action>
      <v-menu
        left
        @lick.stop
      >
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            v-on="on"
          >
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>

        <v-list dense>
          <v-list-item
            v-if="!product.isArchived"
            @click="goto(product.id)"
          >
            <v-list-item-title>
              <v-icon
                left
                small
              >
                edit
              </v-icon>
              Edit
            </v-list-item-title>
          </v-list-item>

          <product-archive-dialog
            v-if="!product.isArchived"
            :id="product.id"
          >
            <template #activator="{ on }">
              <v-list-item
                v-on="on"
                @click.stop=""
              >
                <v-list-item-title class="error--text">
                  <v-icon
                    left
                    small
                    color="error"
                  >
                    archive
                  </v-icon>
                  Archive
                </v-list-item-title>
              </v-list-item>
            </template>
          </product-archive-dialog>

          <v-list-item
            v-if="product.isArchived"
            @click="unarchive()"
          >
            <v-list-item-title>
              <v-icon left small>
                archive
              </v-icon>
              Unarchive
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { get } from 'lodash'
import { mapActions } from 'vuex'
import ProductArchiveDialog from "./ProductArchiveDialog"
import ProductTemplateChip from "./ProductTemplateChip"

export default {
  components: {
    ProductTemplateChip,
    ProductArchiveDialog
  },
  props: {
    product: {
      type: Object,
      default: () => {
      }
    }
  },
  methods: {
    ...mapActions([ 'updateProductAndVariants' ]),
    async unarchive() {
      const payload = {
        isArchived: false,
        id: this.product.id
      }

      await this.updateProductAndVariants(payload)
    },
    goto(id) {
      this.$router.push({ name: 'product-detail', params: { id } })
    },
  },
}
</script>
